import React, { useEffect, useState } from "react";
import { Container, Dropdown, DropdownButton, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PulseLoader from "react-spinners/PulseLoader";
import addicon from "../../assets/images/addicon.svg";
import deleteAction from "../../assets/images/deleteaction.svg";
import profilepic from "../../assets/images/dummy-profile-pic.jpg";
import editAction from "../../assets/images/editaction.svg";
import Invite from "../../assets/images/invitation.svg";
import ContactModal from "../../Modals/ContactModal";
import DeleteModal from "../../Modals/DeleteModal";
import { API_URL } from "../../services/APIRoute";
import {
  InviteToDataFactory,
  InviteToDeveloper,
  SubscribersContactGetList,
  SubscribersContactResendVerificationMail,
} from "../../services/ReduxTookit/Slice/SubscribersContactRedux";
import Loader, { LoaderType } from "../common-component/Loader";
import Nodata from "../common-component/Nodata";
import InviteSubscriberModal from "../../Modals/InviteSubscriberModal";
import { commonservices } from "../../services/CommonServices";

function Contact() {
  const DevRoute = window.location.href.includes(
    `${process.env.REACT_APP_DEV}`
  );
  let ProfileInfo = useSelector((state) => state?.userinfo?.UserInfo);
  const RoleList = useSelector(
    (state) => state?.roleredux?.RoleGetListData?.data?.data?.data?.dataList1
  );

  const dispatch = useDispatch();
  const [ContactLoader, setContactLoader] = useState(false);
  const [SelectedContact, setSelectedContact] = useState({});
  const [ContactModalShow, setContactModalShow] = useState(false);
  const [InviteSubscriberModalShow, setInviteSubscriberModalShow] =
    useState(false);
  const [DeleteContactModalShow, setDeleteContactModalShow] = useState(false);
  const [ContactModalType, setContactModalType] = useState("");
  const [ContactList, setContactList] = useState([]);
  

  const [ChangeStatusIndex, setChangeStatusIndex] = useState({
    index: null,
    isLoading: false,
  });
  const [resend, setResend] = useState(false);
  const [DeletePayload, setDeletePayload] = useState({
    id: "",
    type: "",
  });
  async function getContactList() {
    setContactLoader(true);
    let body = {
      contactname: "",
      email: "",
      contactno: "",
    };
    dispatch(SubscribersContactGetList(body))
      .then((response) => {
        if (response?.payload?.isValidate) {
          setContactList(response?.payload?.data?.data);
        }
        if (!response?.payload?.isValidate) {
          setContactList([]);
        }
      })
      .finally(() => {
        setContactLoader(false);
      });
  }
  useEffect(() => {
    getContactList();
  }, []);

  const InviteForBecomeDeveloper = (id, userid) => {
    let data = {
      subscribercontactid: id,
      developerroleid: 7,
      userid: userid,
    };

    dispatch(InviteToDeveloper(data))?.then((res) => {
      getContactList();
    });
  };

  const FiltredDeveloperrole = ({ ContactList }) => {
    let data = ContactList?.filter((item) => item.developerrole);

    if (data?.length > 0) {
      return data?.map((item, index) => {
        return (
          <tr key={index}>
            <td className="theme-color-text sticky-workflow fw600">
              <div className="d-flex gap-1">
              <img
                className="small-profile-pic"
                src={item?.photourl ? item?.photourl : profilepic}
                alt="profilepic"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = profilepic;
                }}
              />
              <span className="ms-2 contact-user-box" title={item?.contactname}>
                {item?.contactname}
              </span>
              </div>
            </td>
            <td>{item?.email}</td>
            <td className="text-center"> {item?.contactno}</td>
            <td className="text-center">{item?.machine}</td>
            <td className="text-center">{item?.workflow}</td>
            <td>{item?.developerrole}</td>
            <td className="">
              {
                <>
                  {ChangeStatusIndex.index === index &&
                  ChangeStatusIndex.isLoading ? (
                    <>
                      <div className="cursor-pointer text-primary d-flex">
                        <span className="theme-color-text cursor-pointer">
                          Sending
                        </span>
                        <div className="mt-1">
                          <PulseLoader
                            color="#2b8dc8"
                            loading={ChangeStatusIndex.isLoading}
                            size={3}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                            // css={{
                            //   "@media (max-width: 600px)": {
                            //     size: 3,
                            //   },
                            // }}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="cursor-pointer text-primary">
                      {!item?.isemailverified && (
                        <span
                          className="theme-color-text cursor-pointer"
                          onClick={() => {
                            handleResendVerification(
                              index,
                              item?.subscriberscontactid
                            );
                          }}
                        >
                          Resend
                        </span>
                      )}
                    </div>
                  )}
                </>
              }
            </td>
            <td className="mybgtransparant sticky-actions">
              <div className="all-actions invitemain">
                {!item?.workflowrole && (
                  <div className="contact-dropdown">
                    <DropdownButton id="dropdown-basic-button" align="end" drop="down" >
                      {RoleList?.map((items, index) => {
                        return (
                          <Dropdown.Item
                            key={index}
                            onClick={() => {
                              InviteForBecomeClient(
                                item?.subscriberscontactid,
                                items?.roleid,
                                item?.userid
                              );
                            }}
                          >
                            {items?.displayname}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </div>
                  //                   <div className="contact-dropdown">
                  //   <DropdownButton id="dropdown-basic-button" drop="up">
                  //     {RoleList?.map((items, index) => (
                  //       <Dropdown.Item
                  //         key={index}
                  //         onClick={() => {
                  //           InviteForBecomeClient(item?.subscriberscontactid, items?.roleid);
                  //         }}
                  //       >
                  //         {items?.displayname}
                  //       </Dropdown.Item>
                  //     ))}
                  //   </DropdownButton>
                  // </div>
                )}
                <>
                  {item?.contacttype === "Contact" && (
                    <img
                      src={editAction}
                      alt="editAction"
                      title="Edit"
                      onClick={(e) => {
                        e.preventDefault();
                        setSelectedContact(item);
                        setContactModalShow(true);
                        setContactModalType("Update");
                      }}
                    />
                  )}
                  {(item?.contacttype === "Contact" ||
                    item?.contacttype === "Invited") && (
                    <img
                      src={deleteAction}
                      alt="deleteAction"
                      title="Delete"
                      onClick={(e) => {
                        e.preventDefault();
                        setDeleteContactModalShow(true);
                        setDeletePayload({
                          ...DeletePayload,
                          id:
                            item?.contacttype === "Invited"
                              ? item?.userid
                              : item?.subscriberscontactid,
                          type: item?.contacttype,
                        });
                      }}
                    />
                  )}
                </>
              </div>
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr className="text-center">
          <td colSpan={8}>
            <Nodata />
          </td>
        </tr>
      );
    }
  };

  const FilterWorkflowRole = ({ ContactList }) => {
    let data = ContactList?.filter((item) => item.workflowrole);

    if (data?.length > 0) {
      return data?.map((item, index) => {
        return (
          <tr key={index}>
            <td className="theme-color-text fw600 sticky-workflow">
              <div className="d-flex gap-1">
              <img
                className="small-profile-pic"
                src={item?.photourl ? item?.photourl : profilepic}
                alt="profilepic"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = profilepic;
                }}
              />
              <span className="ms-2 contact-user-box" title={item?.contactname}>
                {item?.contactname}
              </span>
              </div>
            </td>
            <td>{item?.email}</td>
            <td className="text-center"> {item?.contactno}</td>
            <td className="text-center">{item?.machine}</td>
            <td className="text-center">{item?.workflow}</td>
            <td>{item?.workflowrole}</td>
            <td>
              {
                <>
                  {ChangeStatusIndex.index === index &&
                  ChangeStatusIndex.isLoading ? (
                    <>
                      <div className="cursor-pointer text-primary d-flex">
                        <span className="theme-color-text cursor-pointer">
                          Sending
                        </span>
                        <div className="mt-1">
                          <PulseLoader
                            color="#2b8dc8"
                            loading={ChangeStatusIndex.isLoading}
                            size={3}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="cursor-pointer text-primary">
                      {!item?.isemailverified && (
                        <span
                          className="theme-color-text cursor-pointer"
                          onClick={() => {
                            handleResendVerification(
                              index,
                              item?.subscriberscontactid
                            );
                          }}
                        >
                          Resend
                        </span>
                      )}
                    </div>
                  )}
                </>
              }
            </td>
            <td className="sticky-actions">
              <div className="all-actions">
                {!item?.developerrole && (
                  <img
                    src={Invite}
                    alt="Invite"
                    title="Invite"
                    onClick={(e) => {
                      e.preventDefault();
                      InviteForBecomeDeveloper(
                        item?.subscriberscontactid,
                        item?.userid
                      );
                    }}
                  />
                )}
                <>
                  {item?.contacttype === "Contact" && (
                    <img
                      src={editAction}
                      alt="editAction"
                      title="Edit"
                      onClick={(e) => {
                        e.preventDefault();
                        setSelectedContact(item);
                        setContactModalShow(true);
                        setContactModalType("Update");
                      }}
                    />
                  )}
                  {(item?.contacttype === "Contact" ||
                    item?.contacttype === "Invited") && (
                    <img
                      src={deleteAction}
                      alt="deleteAction"
                      title="Delete"
                      onClick={(e) => {
                        e.preventDefault();
                        setDeleteContactModalShow(true);
                        setDeletePayload({
                          ...DeletePayload,
                          id:
                            item?.contacttype === "Invited"
                              ? item?.userid
                              : item?.subscriberscontactid,
                          type: item?.contacttype,
                        });
                      }}
                    />
                  )}
                </>
                {/* <img
                  src={editAction}
                  alt="editAction"
                  title="Edit"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedContact(item);
                    setContactModalShow(true);
                    setContactModalType("Update");
                  }}
                />
                <img
                  src={deleteAction}
                  alt="deleteAction"
                  title="Delete"
                  onClick={(e) => {
                    e.preventDefault();
                    setDeleteContactModalShow(true);
                    setDeletePayload({
                      ...DeletePayload,
                      id: item?.subscriberscontactid,
                    });
                  }}
                /> */}
              </div>
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr className="text-center">
          <td colSpan={8}>
            <Nodata />
          </td>
        </tr>
      );
    }
  };

  const InviteForBecomeClient = (id, roleID, userid) => {
    let data = {
      subscribercontactid: id,
      roleid: roleID,
      userid: userid,
    };

    dispatch(InviteToDataFactory(data))?.then((res) => {
      getContactList();
    });
  };
  const handleResendVerification = async (index, machineid) => {
    setChangeStatusIndex({
      ...ChangeStatusIndex,
      index: index,
      isLoading: true,
    });
    setResend(true);

    dispatch(SubscribersContactResendVerificationMail(machineid))?.then(
      (response) => {
        if (response?.isValidate) {
          setResend(false);
          setChangeStatusIndex({
            ...ChangeStatusIndex,
            index: null,
            isLoading: false,
          });
        }

        if (!response?.isValidate) {
          setResend(false);
          setChangeStatusIndex({
            ...ChangeStatusIndex,
            index: null,
            isLoading: false,
          });
        }
      }
    );
  };
  return (
    <div className="projects-page-main compateline-common">
      <>
        <div className="top-bot-section contactpage-inner-set">
          {/* <h6>
            Contacts{ContactList?.length > 0 && ` (${ContactList?.length})`}
          </h6> */}
          <div className="top-bot-right-section">
            <Link>
              <div
                className="filtering-main position-relative"
                id="add-project"
                onClick={(e) => {
                  e.preventDefault();
                  setInviteSubscriberModalShow(true);
                  // setContactModalType("Create");
                }}
                // ref={target}
              >
                <img src={addicon} alt="filtericon" />
                <span>Invite</span>
              </div>
            </Link>
            <Link>
              <div
                className="filtering-main position-relative"
                id="add-project"
                onClick={(e) => {
                  e.preventDefault();
                  setContactModalShow(true);
                  setContactModalType("Create");
                }}
                // ref={target}
              >
                <img src={addicon} alt="filtericon" />
                <span>Add</span>
              </div>
            </Link>
          </div>
        </div>
      </>
      <div className="main-page-content compateline-common mycontacttab">
        <>
          <div className="table-wrapper-main">
            <Table responsive>
              <thead>
                <tr>
                  <th className="width200 sticky-workflow ">Name</th>
                  <th className="width200">Email</th>
                  <th className="width150 text-center">Phone Number</th>
                  <th className="width100 text-center">Machines</th>
                  <th className="width100 text-center">Workflow</th>
                  <th className="width135">Role</th>
                  <th className="width100"></th>
                  <th className="text-end sticky-actions">Action</th>
                </tr>
              </thead>
              <tbody>
                {ContactLoader ? (
                  <Loader type={LoaderType.TableRow} count={10} nooftd={8} />
                ) : (
                  <>
                    {ContactList?.length > 0 ? (
                      <>
                        {DevRoute ? (
                          <FiltredDeveloperrole ContactList={ContactList} />
                        ) : (
                          <FilterWorkflowRole ContactList={ContactList} />
                        )}
                      </>
                    ) : (
                      // ContactList?.map((item, index) => (
                      //   <>
                      //     {DevRoute && item?.developerrole ? (
                      //       <tr key={index}>
                      //         <td className="theme-color-text fw600">
                      //           <img
                      //             className="small-profile-pic"
                      //             src={
                      //               item?.photourl ? item?.photourl : profilepic
                      //             }
                      //             alt="profilepic"
                      //             onError={({ currentTarget }) => {
                      //               currentTarget.onerror = null;
                      //               currentTarget.src = profilepic;
                      //             }}
                      //           />
                      //           <span className="ms-2">
                      //             {item?.contactname}
                      //           </span>
                      //         </td>
                      //         <td>{item?.email}</td>
                      //         <td className="text-center">
                      //           {" "}
                      //           {item?.contactno}
                      //         </td>
                      //         <td className="text-center">{item?.machine}</td>
                      //         <td className="text-center">{item?.workflow}</td>
                      //         <td>{item?.developerrole}</td>
                      //         <td>
                      //           {
                      //             <>
                      //               {ChangeStatusIndex.index === index &&
                      //               ChangeStatusIndex.isLoading ? (
                      //                 <>
                      //                   <div className="cursor-pointer text-primary d-flex">
                      //                     <span className="theme-color-text cursor-pointer">
                      //                       Sending
                      //                     </span>
                      //                     <div className="mt-1">
                      //                       <PulseLoader
                      //                         color="#2b8dc8"
                      //                         loading={
                      //                           ChangeStatusIndex.isLoading
                      //                         }
                      //                         size={3}
                      //                         aria-label="Loading Spinner"
                      //                         data-testid="loader"
                      //                         // css={{
                      //                         //   "@media (max-width: 600px)": {
                      //                         //     size: 3,
                      //                         //   },
                      //                         // }}
                      //                       />
                      //                     </div>
                      //                   </div>
                      //                 </>
                      //               ) : (
                      //                 <div className="cursor-pointer text-primary">
                      //                   {!item?.isemailverified && (
                      //                     <span
                      //                       className="theme-color-text cursor-pointer"
                      //                       onClick={() => {
                      //                         handleResendVerification(
                      //                           index,
                      //                           item?.subscriberscontactid
                      //                         );
                      //                       }}
                      //                     >
                      //                       Resend
                      //                     </span>
                      //                   )}
                      //                 </div>
                      //               )}
                      //             </>
                      //           }
                      //         </td>
                      //         <td className="">
                      //           <div className="all-actions invitemain">
                      //             {!item?.workflowrole && (
                      //               <div className="contact-dropdown">
                      //                 <DropdownButton id="dropdown-basic-button">
                      //                   {RoleList?.map((items, index) => {
                      //                     return (
                      //                       <Dropdown.Item
                      //                         key={index}
                      //                         onClick={() => {
                      //                           InviteForBecomeClient(
                      //                             item?.subscriberscontactid,
                      //                             items?.roleid
                      //                           );
                      //                         }}
                      //                       >
                      //                         {items?.displayname}
                      //                       </Dropdown.Item>
                      //                     );
                      //                   })}
                      //                 </DropdownButton>
                      //               </div>
                      //             )}

                      //             <img
                      //               src={editAction}
                      //               alt="editAction"
                      //               title="Edit"
                      //               onClick={(e) => {
                      //                 e.preventDefault();
                      //                 setSelectedContact(item);
                      //                 setContactModalShow(true);
                      //                 setContactModalType("Update");
                      //               }}
                      //             />
                      //             <img
                      //               src={deleteAction}
                      //               alt="deleteAction"
                      //               title="Delete"
                      //               onClick={(e) => {
                      //                 e.preventDefault();
                      //                 setDeleteContactModalShow(true);
                      //                 setDeletePayload({
                      //                   ...DeletePayload,
                      //                   id: item?.subscriberscontactid,
                      //                 });
                      //               }}
                      //             />
                      //           </div>
                      //         </td>
                      //       </tr>
                      //     ) : (
                      //       <tr className="text-center">
                      //         <td colSpan={8}>
                      //           <Nodata />
                      //         </td>
                      //       </tr>
                      //     )}
                      //     {!DevRoute && item?.workflowrole ? (
                      //      < tr key={index}>
                      //         <td className="theme-color-text fw600">
                      //           <img
                      //             className="small-profile-pic"
                      //             src={
                      //               item?.photourl ? item?.photourl : profilepic
                      //             }
                      //             alt="profilepic"
                      //             onError={({ currentTarget }) => {
                      //               currentTarget.onerror = null;
                      //               currentTarget.src = profilepic;
                      //             }}
                      //           />
                      //           <span className="ms-2">
                      //             {item?.contactname}
                      //           </span>
                      //         </td>
                      //         <td>{item?.email}</td>
                      //         <td className="text-center">
                      //           {" "}
                      //           {item?.contactno}
                      //         </td>
                      //         <td className="text-center">{item?.machine}</td>
                      //         <td className="text-center">{item?.workflow}</td>
                      //         <td>{item?.workflowrole}</td>
                      //         <td>
                      //           {
                      //             <>
                      //               {ChangeStatusIndex.index === index &&
                      //               ChangeStatusIndex.isLoading ? (
                      //                 <>
                      //                   <div className="cursor-pointer text-primary d-flex">
                      //                     <span className="theme-color-text cursor-pointer">
                      //                       Sending
                      //                     </span>
                      //                     <div className="mt-1">
                      //                       <PulseLoader
                      //                         color="#2b8dc8"
                      //                         loading={
                      //                           ChangeStatusIndex.isLoading
                      //                         }
                      //                         size={3}
                      //                         aria-label="Loading Spinner"
                      //                         data-testid="loader"
                      //                         // css={{
                      //                         //   "@media (max-width: 600px)": {
                      //                         //     size: 3,
                      //                         //   },
                      //                         // }}
                      //                       />
                      //                     </div>
                      //                   </div>
                      //                 </>
                      //               ) : (
                      //                 <div className="cursor-pointer text-primary">
                      //                   {!item?.isemailverified && (
                      //                     <span
                      //                       className="theme-color-text cursor-pointer"
                      //                       onClick={() => {
                      //                         handleResendVerification(
                      //                           index,
                      //                           item?.subscriberscontactid
                      //                         );
                      //                       }}
                      //                     >
                      //                       Resend
                      //                     </span>
                      //                   )}
                      //                 </div>
                      //               )}
                      //             </>
                      //           }
                      //         </td>
                      //         <td className="sticky-actions">
                      //           <div className="all-actions">
                      //             {!item?.developerrole && (
                      //               <img
                      //                 src={Invite}
                      //                 alt="Invite"
                      //                 title="Invite"
                      //                 onClick={(e) => {
                      //                   e.preventDefault();
                      //                   InviteForBecomeDeveloper(
                      //                     item?.subscriberscontactid
                      //                   );
                      //                 }}
                      //               />
                      //             )}
                      //             <img
                      //               src={editAction}
                      //               alt="editAction"
                      //               title="Edit"
                      //               onClick={(e) => {
                      //                 e.preventDefault();
                      //                 setSelectedContact(item);
                      //                 setContactModalShow(true);
                      //                 setContactModalType("Update");
                      //               }}
                      //             />
                      //             <img
                      //               src={deleteAction}
                      //               alt="deleteAction"
                      //               title="Delete"
                      //               onClick={(e) => {
                      //                 e.preventDefault();
                      //                 setDeleteContactModalShow(true);
                      //                 setDeletePayload({
                      //                   ...DeletePayload,
                      //                   id: item?.subscriberscontactid,
                      //                 });
                      //               }}
                      //             />
                      //           </div>
                      //         </td>
                      //       </>
                      //     ) : (
                      //       <tr className="text-center">
                      //         <td colSpan={8}>
                      //           <Nodata />
                      //         </td>
                      //       </tr>
                      //     )}
                      //   </>
                      // ))
                      <tr className="text-center">
                        <td colSpan={8}>
                          <Nodata />
                        </td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </Table>
          </div>
        </>
      </div>
      {ContactModalShow && (
        <ContactModal
          selectedcontact={SelectedContact}
          type={ContactModalType}
          show={ContactModalShow}
          bindlist={getContactList}
          onHide={(e) => setContactModalShow(false)}
        />
      )}
      {InviteSubscriberModalShow && (
        <InviteSubscriberModal
          // selectedcontact={SelectedContact}
          // type={ContactModalType}
          show={InviteSubscriberModalShow}
          bindlist={getContactList}
          onHide={(e) => setInviteSubscriberModalShow(false)}
        />
      )}
      {DeleteContactModalShow && (
        <DeleteModal
          payload={DeletePayload}
          url={API_URL.SUBSCRIBERS_CONTACT_DELETE}
          show={DeleteContactModalShow}
          bindlist={getContactList}
          onHide={(e) => setDeleteContactModalShow(false)}
        />
      )}
    </div>
  );
}

export default Contact;
